// Production-safe logger.
//
// devLog/devWarn/devDebug: no-ops in production builds (tree-shaken via
// import.meta.env.DEV constant inlined by Vite). Use for debug breadcrumbs.
//
// logError: always emits a single short, sanitized line. Never pass raw
// Supabase / fetch / DB error objects — pull out a message string yourself.
//
// userMessage: maps any thrown value to a generic, user-safe string suitable
// for toast.error / UI display. Never leaks raw provider errors.

const isDev =
  typeof import.meta !== "undefined" && Boolean((import.meta as any).env?.DEV);

export function devLog(...args: unknown[]): void {
  if (isDev) console.log(...args);
}

export function devWarn(...args: unknown[]): void {
  if (isDev) console.warn(...args);
}

export function devError(...args: unknown[]): void {
  if (isDev) console.error(...args);
}

/**
 * Always-on, sanitized error log. Emits a single line:
 *   [scope] <message>
 * In dev, the original error is appended for debugging.
 */
export function logError(scope: string, err: unknown): void {
  const msg = err instanceof Error ? err.message : "unknown error";
  if (isDev) {
    console.error(`[${scope}] ${msg}`, err);
  } else {
    console.error(`[${scope}] ${msg}`);
  }
}

/**
 * Map any thrown value to a generic, user-safe string for toasts/UI.
 * Strips Supabase/Postgres error codes, RLS hints, stack traces, etc.
 */
export function userMessage(_err: unknown, fallback = "Something went wrong. Please try again."): string {
  return fallback;
}
